import { Channel } from 'spyne';
import { ChannelDeckTraits } from 'traits/deck/channel-deck-traits.js';

export class ChannelDeck extends Channel {
  constructor(name, props = {}) {
    name = 'CHANNEL_DECK';
    props.traits = [ChannelDeckTraits];
    props.replay = true;
    super(name, props);
  }

  onRegistered() {
    this.channelDeck$OnRegistered();
  }

  addRegisteredActions() {
    return ['CHANNEL_DECK_INIT_EVENT'];
  }
}
